import React, { ReactElement, useCallback, useState } from 'react';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { getNameById } from 'reactApp/modules/file/utils';

import styles from './SharingNewUnMount.css';
import { EAction, IProps } from './SharingNewUnMount.types';

export const SharingNewUnMount = React.memo(function SharingNewUnMount(props: IProps): ReactElement {
    const { info, onClose, onUnmount } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const folderName = info.name || getNameById(info.home || '');

    const onConfirm = useCallback(() => {
        setLoading(true);
        onUnmount(EAction.UNMOUNT);
    }, [onUnmount]);

    const onRemoveItem = useCallback(() => {
        setLoading(true);
        onUnmount(EAction.REMOVE);
    }, [onUnmount]);

    const renderHeader = useCallback(() => <div>Отказ от доступа</div>, []);

    const renderContent = useCallback(() => {
        return (
            <div>
                Вы действительно хотите отказаться от доступа {info.access === 'read_only' ? '(только просмотр)' : '(редактирование)'} к
                папке «{folderName}» пользователя «{info.owner.email}»?
            </div>
        );
    }, [info.access, folderName, info.owner.email]);

    return (
        <BaseConfirmDialog
            renderHeader={renderHeader}
            successButtonText="Отказаться"
            actionButtonText="Отказаться и удалить папку"
            cancelButtonText="Отменить"
            buttons={[EButtonType.accept, EButtonType.action, EButtonType.cancel]}
            onClose={onClose}
            onAction={onRemoveItem}
            onSuccess={onConfirm}
            renderContent={renderContent}
            className={styles.root}
            loading={loading}
        />
    );
});
